import {useDispatch,useSelector} from 'react-redux'
import {
	selectShow as selectShowMessageCenter,
	setShow as setShowMessageCenter,
	selectMemberPrivateRoomId,
	getChatRoom,
} from '../MessageCenter/messageCenterSlice'
import useBranding from '../../hooks/useBranding'
import styles from './StickyChatToggle.module.css'

const StickyChatToggle = ()=>{
	const dispatch = useDispatch()
	const messageCenterOpen = useSelector(selectShowMessageCenter)
	const isClient = useSelector(state=>state.users.current_user.account_type === 'client')
	const customBranding = useBranding()
	const trainerProfilePic = useSelector(state=>state.users.current_user.trainer_data?.trainerProfilePic)
	const trainer_id = useSelector(state=>state.users.current_user.trainer_data?.trainer_id)
	const room_id = useSelector(
		state => selectMemberPrivateRoomId(state,trainer_id)
	)
	const handleClick = ()=>{
		dispatch(setShowMessageCenter(true))
		dispatch(getChatRoom({room_id}))
	}
	if(!isClient) return null
	return (
		<div 
			onClick={handleClick}
			className={[
				styles.TrainerBubble,
				'shadow',
				!messageCenterOpen?styles.Show:''
			].join(' ')}
			style={{
				borderColor:customBranding ? customBranding.textColor : "",
				color:customBranding ? customBranding.textColor : "",
				background:customBranding ? customBranding.backgroundColor : ""
			}}
		>
			{trainerProfilePic?
				<div className="position-relative">
					<img alt="trainer" src={trainerProfilePic}/>
					<i 
						className="fas fa-comments" 
						style={{
							position:'absolute',
							top:'50%',
							left:'50%',
							transform:'translate(-50%,-50%)',
							fontSize:'20px',
							textShadow:'0 0 16px #000'
						}}
					/>
				</div>:
				<i className="fas fa-comments"></i>
			}
		</div>
	)
}

export default StickyChatToggle